import { getCurrentWeekNumber } from '../../utils/datetime/datetime-comprehensive';

// Calculate pending tasks (same logic as Dashboard)
export const calculatePendingTasks = (allActiveAssignments, quizzes) => {
  let pendingCount = 0;

  // Count pending non-weekly assignments
  const nonWeeklyAssignments = allActiveAssignments.filter(a => !a.allow_weekly_submissions && !a.submitted_at);
  pendingCount += nonWeeklyAssignments.length;

  // Count pending weekly assignments (by week)
  const weeklyAssignments = allActiveAssignments.filter(a => a.allow_weekly_submissions);
  for (const assignment of weeklyAssignments) {
    // Calculate total weeks based on start_date
    let totalWeeks = 0;
    if (assignment.start_date) {
      const breakPeriods = Array.isArray(assignment.break_periods) ? assignment.break_periods : [];
      const currentWeek = getCurrentWeekNumber(assignment.start_date, null, breakPeriods);
      const parsedMaxWeeks = Number(assignment.max_weekly_submissions);
      const maxWeeks = Number.isFinite(parsedMaxWeeks) && parsedMaxWeeks > 0
        ? Math.floor(parsedMaxWeeks)
        : 1;
      totalWeeks = Math.min(currentWeek > 0 ? currentWeek : 0, maxWeeks);
    }

    let submittedWeeks = assignment.submitted_week_numbers || [];
    if (typeof submittedWeeks === 'string') {
      try {
        submittedWeeks = JSON.parse(submittedWeeks);
      } catch (e) {
        submittedWeeks = [];
      }
    }
    const pendingWeeks = totalWeeks - (Array.isArray(submittedWeeks) ? submittedWeeks.length : 0);
    pendingCount += Math.max(0, pendingWeeks);
  }

  // Count pending quizzes (quizzes that haven't been started or are in progress)
  const pendingQuizzes = quizzes.filter(q =>
    (q.course_is_active === 1 || q.course_is_active === true) &&
    (q.status === 'not_started' || q.status === 'in_progress')
  ).length;
  pendingCount += pendingQuizzes;

  return pendingCount;
};

// Calculate completed tasks (same logic as Dashboard)
export const calculateCompletedTasks = (allActiveAssignments, quizzes) => {
  let completedCount = 0;

  // Count completed non-weekly assignments
  const nonWeeklyAssignments = allActiveAssignments.filter(a => !a.allow_weekly_submissions && a.submitted_at);
  completedCount += nonWeeklyAssignments.length;

  // Count completed weekly assignments (by week)
  const weeklyAssignments = allActiveAssignments.filter(a => a.allow_weekly_submissions);
  for (const assignment of weeklyAssignments) {
    let submittedWeeks = assignment.submitted_week_numbers || [];
    if (typeof submittedWeeks === 'string') {
      try {
        submittedWeeks = JSON.parse(submittedWeeks);
      } catch (e) {
        submittedWeeks = [];
      }
    }
    completedCount += Array.isArray(submittedWeeks) ? submittedWeeks.length : 0;
  }

  // Count completed quizzes (only quizzes with status 'completed')
  const completedQuizzes = quizzes.filter(q =>
    (q.course_is_active === 1 || q.course_is_active === true) &&
    q.status === 'completed'
  ).length;
  completedCount += completedQuizzes;

  return completedCount;
};
